import HomePage from "@/pages/HomePage";

const Index = () => {
  return <HomePage />;
};

export default Index;
